/* ============================================================================
   Color family grid — client-side filtering + "Mehr anzeigen" reveal.
   Page templates can't use Shopify's native collection.filters, so the grid
   carries per-card data attributes (data-brand/-material/-weight/-uses) and we
   filter in JS. Filtering overrides the show-more cap (so all matches surface);
   clearing restores the cap.
   ========================================================================== */
(function () {
  var BATCH = 60;

  function init(section) {
    var cells = Array.prototype.slice.call(section.querySelectorAll('.sbc-grid__cell'));
    if (!cells.length) return;

    var moreBtn = section.querySelector('[data-color-grid-more]');
    var clearBtn = section.querySelector('[data-sbc-clear]');
    var countEl = section.querySelector('[data-sbc-count]');
    var checks = Array.prototype.slice.call(section.querySelectorAll('[data-sbc-filter]'));

    // Cards initially visible (server-rendered cap).
    var initialCap = cells.filter(function (c) { return !c.classList.contains('is-hidden'); }).length || cells.length;
    var revealed = initialCap;

    function cellVals(cell, dim) {
      return (cell.dataset[dim] || '').split(',').filter(Boolean);
    }

    function activeByDim() {
      var map = {};
      checks.forEach(function (cb) {
        if (cb.checked) {
          if (!map[cb.dataset.dim]) map[cb.dataset.dim] = {};
          map[cb.dataset.dim][cb.value] = true;
        }
      });
      return map;
    }

    function matches(cell, map) {
      for (var dim in map) {
        if (!Object.prototype.hasOwnProperty.call(map, dim)) continue;
        var vals = cellVals(cell, dim);
        var hit = vals.some(function (v) { return map[dim][v]; });
        if (!hit) return false; // AND across dimensions, OR within one
      }
      return true;
    }

    function apply() {
      var map = activeByDim();
      var anyActive = Object.keys(map).length > 0;

      if (anyActive) {
        var n = 0;
        cells.forEach(function (cell) {
          var ok = matches(cell, map);
          cell.classList.remove('is-hidden'); // cap overridden while filtering
          cell.classList.toggle('is-filtered-out', !ok);
          cell.hidden = !ok;
          if (ok) n++;
        });
        if (moreBtn) moreBtn.hidden = true;
        if (clearBtn) clearBtn.hidden = false;
        if (countEl) countEl.textContent = n;
      } else {
        cells.forEach(function (cell, i) {
          cell.classList.remove('is-filtered-out');
          var hide = i >= revealed;
          cell.classList.toggle('is-hidden', hide);
          cell.hidden = hide;
        });
        if (moreBtn) moreBtn.hidden = revealed >= cells.length;
        if (clearBtn) clearBtn.hidden = true;
        if (countEl) countEl.textContent = cells.length;
      }
    }

    checks.forEach(function (cb) { cb.addEventListener('change', apply); });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        checks.forEach(function (c) { c.checked = false; });
        apply();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        revealed = Math.min(revealed + BATCH, cells.length);
        apply();
      });
    }
  }

  document.querySelectorAll('[data-color-grid]').forEach(init);
})();
